import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Container, Nav, Row, Spinner } from "react-bootstrap";
import BreadcrumbSection from "components/BreadcrumbSection";
import { Link } from "react-router-dom";
import { resourceListing } from "api/CategoryService";
import { stripHtmlTags } from "utils/helpers";
import { Sentry } from "react-activity";
import Loader from "components/Loader";
const Resources = () => {
  const [activeTab, setActiveTab] = useState("");
  const [resourceSections, setResourceSections] = useState({});
  const [sectionRefs, setSectionRefs] = useState({});
  const [loading, setLoading] = useState(true);
  const [pageLoading, setPageLoading] = useState(true);
  const navRef = useRef(null);

  useEffect(() => {
    const fetchResources = async () => {
      try {
        const res = await resourceListing(); // Your API call
        if (res.success && res.body) {
          setResourceSections(res.body);
          setActiveTab(Object.keys(res.body)[0]); // Set first tab active by default

          // Create dynamic refs
          const refs = {};
          Object.keys(res.body).forEach((key) => {
            refs[key] = React.createRef();
          });
          setSectionRefs(refs);
        }
      } catch (error) {
        console.error("Error fetching resources", error);
      } finally {
        setLoading(false);
        setPageLoading(false);
      }
    };

    fetchResources();
  }, []);

  // Smooth scroll to section
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    sectionRefs[tab]?.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  // Hide scrollbar styling
  useEffect(() => {
    if (navRef.current) {
      navRef.current.style.scrollbarWidth = "none";
      navRef.current.style.overflowX = "auto";
      navRef.current.style.whiteSpace = "nowrap";
    }
  }, []);

  return pageLoading ? (
    <div className="loaderdiv">
      {/* <Sentry color="#e91515" size={40} speed={1} animating={true} /> */}
      <Loader />
    </div>
  ) : (
    <>
      <BreadcrumbSection breadcrumbs={[{ title: "Resources" }]} />

      <section className="software_section pt-5">
        <Container>
          <Row className="mb-4">
            <Col lg={12}>
              <div className="software_header mb-3">
                <h2>Resources</h2>
              </div>

              {loading ? (
                <div className="text-center py-5">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : (
                <Row style={{ padding: "0px" }} className="resources_section">
                           <div className="nav_Flex mb-4 header_profile2" style={{padding: "0px"}}>
                      <div className="scroll-container" ref={navRef}>
                        <Nav variant="tabs" className="flex-nowrap">
                          {Object.keys(resourceSections).map((tab) => (
                            <Nav.Item key={tab}>
                              <Nav.Link
                                active={activeTab === tab}
                                onClick={() => handleTabClick(tab)}
                                style={{
                                  backgroundColor: activeTab === tab ? "#E91515" : "transparent",
                                  color: activeTab === tab ? "white" : "black",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {tab}
                              </Nav.Link>
                            </Nav.Item>
                          ))}
                        </Nav>
                      </div>
                    </div>
                  <Col md={12} >
                    <div className="nav_Flex mb-4 header_profile3">
                      <div className="scroll-container" ref={navRef}>
                        <Nav variant="tabs" className="flex-nowrap">
                          {Object.keys(resourceSections).map((tab) => (
                            <Nav.Item key={tab}>
                              <Nav.Link
                                active={activeTab === tab}
                                onClick={() => handleTabClick(tab)}
                                style={{
                                  backgroundColor:
                                    activeTab === tab
                                      ? "#E91515"
                                      : "transparent",
                                  color: activeTab === tab ? "white" : "black",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {tab}
                              </Nav.Link>
                            </Nav.Item>
                          ))}
                        </Nav>
                      </div>
                    </div>

                    {/* Resource Sections */}
                    {Object.entries(resourceSections).map(
                      ([section, items]) => (
                        <div
                          key={section}
                          ref={sectionRefs[section]}
                          className="mb-4"
                        >
                          <div className="mb-3 linkHeader">
                            <h3 className="mb-0">{section}</h3>
                            {items.length > 3 && (
                              <Link
                                to={`/resources-all/${encodeURIComponent(
                                  items[0]?.postCategoryId
                                )}`}
                              >
                                View All
                              </Link>
                            )}
                          </div>
                          <Row className="mb-3">
                            {items.map((card, index) => (
                              <Col
                                md={6}
                                lg={4}
                                sm={6}
                                key={index}
                                className="mb-4"
                              >
                                <Card className="h-100 res_Card">
                                  <Link to={`/resources-details/${card._id}`}>
                                    <Card.Img
                                      variant="top"
                                      src={card.mediaUrl}
                                    />
                                  </Link>
                                  <Card.Body>
                                    <Card.Text className="tag">
                                      {card.tag}
                                    </Card.Text>
                                    <Link to={`/resources-details/${card._id}`}>
                                      <Card.Title>{card.title}</Card.Title>
                                    </Link>
                                    <Card.Text className="para">
                                      {stripHtmlTags(card.description)?.slice(
                                        0,
                                        100
                                      )}
                                      ...
                                    </Card.Text>
                                  </Card.Body>
                                </Card>
                              </Col>
                            ))}
                          </Row>
                        </div>
                      )
                    )}
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Resources;
